// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/AlertTranslation/alert.css
// module id = 1604
// module chunks = 193